import { useQuery } from 'react-query';
import { useZoneContext } from '../../contexts/useZoneContext';
import ApiClient from '../../services/apiClient';
import { IStaticItemLookupModel } from '../../interfaces/ILookup';
const _apiClient = new ApiClient();

export const useQuadCaseStaticItemsByAuthorizedZones = (caseFileModelId: number, organizationGuids: string[] = [], enabled: boolean = true) => {
    const { zoneApiClient } = useZoneContext();
    return useQuery<IStaticItemLookupModel[]>({
        queryKey: [ 'get-quad-case-static-items',  caseFileModelId, organizationGuids,],
        enabled: enabled, //prevents premature fetch
        queryFn: async () => {
            const response = await _apiClient.getQuadCaseStaticItemsByAuthorizedZones(
                caseFileModelId.toString(),
                organizationGuids
            );

            if (response.httpResponse.status === 401) {
                window.location.reload();
            }

            if (response.httpResponse.status === 500) {
                throw new Error('Failed to retrieve quad case static items.');
            } else if (response.errorMessage) {
                throw new Error(response.errorMessage);
            }

            return response.payload ?? [];
        },
    });
};

